import { expVal } from '@atlassian/jira-feature-experiments';
import { getCapabilityMetadataHeaders } from '@jira/platform__app-framework-ufo-capability-header/src/getCapabilityMetadataHeaders.tsx';
import {
	CAPABILITY_LOAD_TYPE,
	FE_UNATTRIBUTED,
} from '@jira/platform__observability-capabilities/src/constants.tsx';

type RouteCapabilityContext = {
	readonly isPrefetch?: boolean;
	readonly route?: {
		readonly meta?: {
			readonly capability?: string | null;
		} | null;
	} | null;
};

type RouteCapabilityHeaderOptions = {
	readonly existingHeaders?: unknown;
};

export const getRouteCapabilityHeaders = (
	routeContext: RouteCapabilityContext | null | undefined,
	{ existingHeaders }: RouteCapabilityHeaderOptions = {},
): Record<string, string> | undefined => {
	if (!expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)) {
		return undefined;
	}

	const capability = routeContext?.route?.meta?.capability;
	const isPrefetch = routeContext?.isPrefetch;

	if (capability == null && !isPrefetch) {
		return undefined;
	}

	return getCapabilityMetadataHeaders(
		existingHeaders,
		capability ?? FE_UNATTRIBUTED,
		isPrefetch ? CAPABILITY_LOAD_TYPE.PREFETCH : undefined,
	);
};
